module.exports = __webpack_public_path__ + "static/media/wallace.80081e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ExampleCarousel/assets/wallace.png
// module id = 456
// module chunks = 0